export default __webpack_public_path__ + "images/dda4d65964aa672964d970102640feb7-maria.webp";